import { apiClient } from "../apiClient";

const HINH_THUC_GIANG_API = "hinh-thuc-giang";
export const hinhThucGiangApi = {
    SelectAll: () => apiClient.get(`${HINH_THUC_GIANG_API}`),
};